import { ISession, GET_CURRENT_SESSION } from '../types/session.types';
import authApolloClient from './apollo.authClient';

export const getCurrentSession = async (sessionId: string, shouldRefresh = false): Promise<ISession | null> => {
  try {
    const res = await authApolloClient.query({
      query: GET_CURRENT_SESSION,
      context: {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      },
      variables: {
        refresh: shouldRefresh,
      },
    });
    return res.data?.getSession;
  } catch (e) {
    console.error('🚀 ~ getCurrentSession ~ e:', e);
    return null;
  }
};

export const getClientSideSession = async (shouldRefresh = false): Promise<ISession | null> => {
  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href);
    const platform = url.searchParams.get('platform') || '';
    const isAppUser = Boolean(platform === 'app');
    const sessionId = url.searchParams.get('sessionId') || '';

    if (sessionId) {
      const data = await getCurrentSession(sessionId || '', shouldRefresh);

      if (data) {
        return data;
      } else {
        return null;
      }
    } else if (isAppUser) {
      const accessToken = url.searchParams.get('accessToken') || '';
      const idToken = url.searchParams.get('idToken') || '';
      return {
        accessToken,
        idToken,
        sessionId: '',
      };
    } else {
      return null;
    }
  } else {
    return null;
  }
};


export function getTokenFromCookies(cookieName: string): string | null {
  try {
    // Validate input
    if (!cookieName || typeof cookieName !== 'string') {
      throw new Error('Invalid cookie name provided.');
    }

    // Check if cookies are accessible (basic feature detection for older environments)
    if (typeof document === 'undefined' || typeof document.cookie === 'undefined') {
      throw new Error('Cookies are not accessible in this environment.');
    }

    // Match the cookie name using a regular expression
    const cookiePattern = new RegExp(`(^|;\\s*)${cookieName}=([^;]*)`);
    const match = document.cookie.match(cookiePattern);

    // Return the token if found, otherwise null
    return match ? decodeURIComponent(match[2]) : null;
  } catch (error) {
    console.error('Error getting token from cookies:', error);
    return null; // Fail gracefully
  }
}